export default "__VITE_ASSET__7gzBMlvd__"